
<div class="card-body">
  <div class="container">
      <div class="row" style="background-color: rgba#e2e2e2;">
        <p>1.Diligencie los datos de la empresa</p>
          <div class="col">
              <input type="text"  [(ngModel)]="nombre" class="form-control" placeholder="Nombre empresa: " (input)="validaboton()"   >
          </div>
          <div class="col">
            <div class="input-group mb-3">
                <input type="text" [(ngModel)]="dominio" class="form-control" placeholder="Dominio: @nombredelaempresa.com" (input)="validaboton()"  >
              </div>
          </div>
          <div class="col">
              <input type="text"  [(ngModel)]="responsable" class="form-control" placeholder="Responsable" (input)="validaboton()" >
          </div>
      </div>
      <hr>
   
      
  </div>
  <div *ngIf="alertaActiva">
      <p>
          <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }}</ngb-alert>
      </p>
  </div>
  
  <div>
    <hr>
    <button class="btn btn-success btn-block" (click)="crearEmpresa()" [disabled]="botondisabled" style="float: right; margin-right: 6px;"  >¡Crear empresa!</button>
  </div>
</div>

<div>
    <div  color="light" >
      <div style="text-align: center; color: rgb(15, 71, 145);"><h3>Lista de empresas activas</h3></div>
      <!-- <div style="text-align: center; color: rgb(15, 71, 145);"><p>Los usuarios activos son los que ya han actualizado sus datos y pueden utilizar activamente la aplicación.</p></div> -->
      

        <table datatable [dtOptions]="dtOptions"[dtTrigger]="dtTrigger" class="row-border hover" id="tabla"  >
          <thead>
            <tr>
              <th>Acciones</th>
              <th>Nombre</th>
              <th>Dominio</th>
              <th>Responsable</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of arraydeposts">
              <td><button type="button" class="btn btn-primary btn-sm" (click)="editarEmpresa(item)"> Acciones</button></td>
              <td>{{item.data().nombre}}</td>
              <td>{{item.data().dominio}}</td>
              <td>{{item.data().responsable}}</td>
            </tr>
          </tbody>
        </table>

       </div> 
</div>

